import styled from 'styled-components';

export const StyledMultiSelectContainer = styled.div`
  .dropdown-container {
    border: 1px solid ${({ theme }) => theme.colors.bordaInput} !important;
    border-radius: 10px !important;
  }

  .dropdown-heading {
    min-height: 38px;
    padding: 6px 10px;
    border-radius: 10px;
    color: ${({ theme }) => theme.colors.textoComum};

    .dropdown-heading-value {
      color: ${({ theme }) => theme.colors.textoComum};
    }
  }

  .dropdown-content {
    border-radius: 10px;
    z-index: 9999;
    max-height: 300px;
    border: 1px solid ${({ theme }) => theme.colors.bordaInput};

    .panel-content {
      max-height: 280px;
    }
  }

  .item-renderer {
    padding: 8px;
    border-radius: 8px;
    margin: 2px 4px;
    transition: background-color 0.2s;

    &.selected {
      background-color: ${({ theme }) => theme.colors.azulgov};
      color: white;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.azulgov}20;
    }

    input[type='checkbox'] {
      accent-color: ${({ theme }) => theme.colors.azulgov};
    }
  }

  .select-all {
    padding: 8px;
    border-radius: 8px;
    margin: 2px 4px;
  }

  .search {
    input {
      border-radius: 10px;
      border: 1px solid ${({ theme }) => theme.colors.bordaInput};
      padding: 6px 10px;
      min-height: 38px;
      transition: all 0.2s;

      &:focus {
        border-color: ${({ theme }) => theme.colors.azulgov};
        box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.azulgov}40;
      }
    }
  }

  .disabled {
    background-color: ${({ theme }) => theme.colors.cinza}30;
    cursor: not-allowed;

    .dropdown-heading {
      background-color: ${({ theme }) => theme.colors.cinza}30;
      color: ${({ theme }) => theme.colors.cinza};
      cursor: not-allowed;
    }
  }
`;
